import React from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import * as api from '../elements/api/api';
import * as cf from '../elements/api/CoreFunctions';
import { Notyf } from 'notyf';




function AddClip(props) {
  const notyf = new Notyf(
    {
      dismissible: true
    }
  );

  const [url, setUrl] = React.useState("");
  const [type, setType] = React.useState("");
  const [additionalActionBookmark, setAdditionalActionBookmark] = React.useState(false);
  const [additionalActionPlaylist, setAdditionalActionPlaylist] = React.useState(false);

  const storeMailAddress = (sendMail) => {
    if(sendMail ) {
      api.storeMailAddress(props.mail);
    }
    else{
      api.storeMailAddress("");
    }
  };

  const removeChild = (id) => {
    let newRows = props.rows.filter(row => row.id !== id);
    props.setRows(newRows);
  }

  const addClipToBookmarksButtonClicked = () => {

    const onBeforeApiCall = () => {
      setUrl("");
    };

    const mail = props.sendMailNotification ? props.mail : ""

    cf.addBookmark(url)
  

  };

    const addClipToQueueButtonClicked = () => {

    const onBeforeApiCall = () => {
      setUrl("");
    };

    const mail = props.sendMailNotification ? props.mail : ""

    cf.addJob(props.rows,type,url,mail,props.setRows,onBeforeApiCall,props.openSelectLanguageForm);
    console.log({[cf.ADDITIONAL_ACTION_ADD_TO_PLAYLIST]:additionalActionPlaylist, [cf.ADDITIONAL_ACTION_ADD_TO_BOOKMARKS]: additionalActionBookmark})
    props.addToAdditionalActions(url,{[cf.ADDITIONAL_ACTION_ADD_TO_PLAYLIST]:additionalActionPlaylist, [cf.ADDITIONAL_ACTION_ADD_TO_BOOKMARKS]: additionalActionBookmark})
  };


  return (
    <div>
      <h4>Add Clip</h4>
      <Form.Group className="mb-3 border p-3 rounded">
        <Form.Label>Enter URL of a YouTube clip you want to download</Form.Label>
        <Form.Control value={url} onChange={(e) => { setUrl(e.target.value); }} placeholder="URL" />
        <Form.Label>Select type</Form.Label>
        <Form.Check onChange={() => setType("audio")} type="Radio" name="type" value="audio" label="Audio" />
        <Form.Check onChange={() => setType("video")} type="Radio" name="type" value="video" label="Video" />
        <Form.Label>Additional actions</Form.Label>
         <Form.Check onChange={() => setAdditionalActionBookmark(!additionalActionBookmark)} type="checkbox" label="Add to bookmark list" />
        <Form.Check onChange={() => setAdditionalActionPlaylist(!additionalActionPlaylist)} type="checkbox"  label="Add to playlist" />
      </Form.Group>
      <Button onClick={addClipToQueueButtonClicked} className="me-2" variant="primary">Add clip to queue</Button> 
      <Button onClick={addClipToBookmarksButtonClicked} variant="primary">Add clip to bookmarks</Button>

    </div>
  );
}

export default AddClip;